let documentUrl;
let hostname;
let baseUrl;
let domain;
let channelId = null;

if (document.currentScript && document.currentScript.src) {
    documentUrl = document.currentScript.src.split("/");
    hostname = new URL(documentUrl.join("")).hostname;
    baseUrl = documentUrl[0] + "//" + documentUrl[2] + "/";
    domain = documentUrl[2];
    // ek web chat kanalinin gomme kodu: loader.js?channel=<kanal id>
    const channelMatch = /[?&]channel=([a-f0-9]{24})(&|$)/i.exec(document.currentScript.src);
    channelId = channelMatch ? channelMatch[1] : null;
} else {
    // Fallback defaults based on environment
    // Try to detect environment from build variables or window.location
    let env = process.env.ENVIRONMENT;
    if (!env && typeof window !== "undefined") {
        if (window.location.hostname.startsWith("local")) {
            env = "local";
        } else if (window.location.hostname.startsWith("beta")) {
            env = "stage";
        } else {
            env = "production";
        }
    }
    if (env === "local") {
        hostname = "localvisitor.supsis.live";
        baseUrl = "http://localvisitor.supsis.live/";
        domain = "localvisitor.supsis.live";
    } else if (env === "stage") {
        hostname = "betavisitor.supsis.live";
        baseUrl = "https://betavisitor.supsis.live/";
        domain = "betavisitor.supsis.live";
    } else {
        hostname = "visitor.supsis.live";
        baseUrl = "https://visitor.supsis.live/";
        domain = "visitor.supsis.live";
    }
    documentUrl = [baseUrl];
}

const CONFIG = {
    TABLET_URL: process.env.TABLET_URL,
    IS_PROD_ENV: process.env.ENVIRONMENT === "production",
    IS_STAGE_ENV: process.env.ENVIRONMENT === "stage",
    DOCUMENT_URL: documentUrl,
    SCRIPT_HOSTNAME: hostname,
    BASE_URL: baseUrl,
    DOMAIN: domain,
    CHANNEL_ID: channelId,
    VISITOR_POWERED_BY_LINK: {
        VATANCOMPUTER: "663a324c03b195ef5bf18302", // Vatan Computer Site ID
    },
};
export default CONFIG;



//////////////////
// WEBPACK FOOTER
// ./static/src/config.js
// module id = 67dr
// module chunks = 1 2